import React from 'react';

export function ServiceIllustration({ name, className = "w-20 h-20" }) {
  const strokeColor = "#0B0E14";
  const accentColor = "#206FEA";
  const fillColor = "#E6EBEF";
  const secondaryFill = "#ffffff";

  switch (name) {
    case 'pillefyr':
      return (
        <svg viewBox="0 0 100 100" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
          {/* Main Boiler Body */}
          <rect x="20" y="25" width="36" height="58" rx="4" fill={fillColor} stroke={strokeColor} strokeWidth="2.5" />
          <rect x="26" y="32" width="24" height="16" rx="2" fill="#192330" />
          <circle cx="38" cy="40" r="3" fill={accentColor} />
          
          {/* Pellet Hopper Side Unit */}
          <path d="M56 38 H78 V78 H56 Z" fill={secondaryFill} stroke={strokeColor} strokeWidth="2.5" />
          <path d="M56 38 L62 25 H84 L78 38 Z" fill={fillColor} stroke={strokeColor} strokeWidth="2.5" />
          
          {/* Pipe connection */}
          <path d="M38 25 V12 H50 V20" stroke={accentColor} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M56 60 H48" stroke={strokeColor} strokeWidth="3" strokeLinecap="round" />

          {/* Flame Icon on Door */}
          <path d="M38 72 C33 72 31 67 34 63 C35 61 38 58 38 55 C40 58 43 61 43 65 C43 69 41 72 38 72 Z" fill={accentColor} />
        </svg>
      );

    case 'luft-til-luft':
      return (
        <svg viewBox="0 0 100 100" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
          {/* Indoor Split Unit */}
          <rect x="12" y="16" width="76" height="26" rx="4" fill={fillColor} stroke={strokeColor} strokeWidth="2.5" />
          <line x1="18" y1="36" x2="82" y2="36" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />
          <circle cx="22" cy="24" r="2" fill={accentColor} />
          <rect x="68" y="22" width="12" height="4" rx="1" fill="#192330" />
          
          {/* Airflow Wave Arrows */}
          <path d="M28 44 C34 50 40 50 46 44 C52 38 58 38 64 44" stroke={accentColor} strokeWidth="2.5" strokeLinecap="round" />
          <path d="M34 52 C40 58 46 58 52 52 C58 46 64 46 70 52" stroke={strokeColor} strokeWidth="2" strokeDasharray="3 3" strokeLinecap="round" />

          {/* Outdoor Fan Unit */}
          <rect x="25" y="58" width="50" height="32" rx="4" fill={secondaryFill} stroke={strokeColor} strokeWidth="2.5" />
          <circle cx="42" cy="74" r="10" fill={fillColor} stroke={strokeColor} strokeWidth="2" />
          <path d="M42 66 L42 82 M34 74 L50 74" stroke={strokeColor} strokeWidth="2" />
          <circle cx="42" cy="74" r="3" fill={accentColor} />
          <rect x="58" y="66" width="10" height="16" rx="1" fill="#192330" opacity="0.2" />
        </svg>
      );

    case 'luft-til-vand':
      return (
        <svg viewBox="0 0 100 100" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
          {/* Heat Pump Outdoor Monoblock */}
          <rect x="10" y="32" width="44" height="52" rx="4" fill={fillColor} stroke={strokeColor} strokeWidth="2.5" />
          <circle cx="32" cy="58" r="14" fill={secondaryFill} stroke={strokeColor} strokeWidth="2" />
          <path d="M32 47 L32 69 M21 58 L43 58" stroke={strokeColor} strokeWidth="2" />
          <circle cx="32" cy="58" r="4" fill={accentColor} />

          {/* Hot Water Storage Tank */}
          <rect x="64" y="20" width="26" height="64" rx="12" fill={secondaryFill} stroke={strokeColor} strokeWidth="2.5" />
          <path d="M70 30 H84" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />
          <path d="M70 40 H84" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />
          <circle cx="77" cy="55" r="4" fill={accentColor} />

          {/* Insulated Pipe Loop */}
          <path d="M54 44 H64 M54 70 H64" stroke={accentColor} strokeWidth="3" strokeLinecap="round" />
        </svg>
      );

    case 'solceller':
      return (
        <svg viewBox="0 0 100 100" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
          {/* Sun Icon */}
          <circle cx="22" cy="22" r="8" fill={accentColor} />
          <path d="M22 8 V12 M22 32 V36 M8 22 H12 M32 22 H36 M12 12 L15 15 M29 29 L32 32 M12 32 L15 29 M29 15 L32 12" stroke={accentColor} strokeWidth="2" strokeLinecap="round" />

          {/* Solar Panel Array Grid */}
          <path d="M15 78 L35 42 H85 L65 78 Z" fill={fillColor} stroke={strokeColor} strokeWidth="2.5" />
          {/* Grid lines */}
          <line x1="40" y1="42" x2="25" y2="78" stroke={strokeColor} strokeWidth="1.5" />
          <line x1="62" y1="42" x2="45" y2="78" stroke={strokeColor} strokeWidth="1.5" />
          <line x1="25" y1="60" x2="75" y2="60" stroke={strokeColor} strokeWidth="1.5" />

          {/* Energy Ray Spark */}
          <path d="M78 20 L70 34 H76 L68 48" stroke={accentColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );

    case 'varmepumpe-service':
      return (
        <svg viewBox="0 0 100 100" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
          {/* Service Shield Base */}
          <path d="M50 14 L80 24 V50 C80 68 50 86 50 86 C50 86 20 68 20 50 V24 L50 14 Z" fill={fillColor} stroke={strokeColor} strokeWidth="2.5" />
          
          {/* Diagnostic Pressure Gauge */}
          <circle cx="50" cy="46" r="16" fill={secondaryFill} stroke={strokeColor} strokeWidth="2" />
          <path d="M50 46 L58 40" stroke={accentColor} strokeWidth="2.5" strokeLinecap="round" />
          <circle cx="50" cy="46" r="3" fill={strokeColor} />
          
          {/* Checkmark underneath */}
          <path d="M40 68 L47 74 L60 60" stroke={strokeColor} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );

    case 'montage':
      return (
        <svg viewBox="0 0 100 100" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
          {/* Pipe Network / Valves */}
          <path d="M15 35 H85 V65 H50 V85" stroke={strokeColor} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="35" cy="35" r="7" fill={fillColor} stroke={strokeColor} strokeWidth="2" />
          <circle cx="65" cy="35" r="7" fill={fillColor} stroke={strokeColor} strokeWidth="2" />
          <rect x="46" y="55" width="8" height="12" fill={accentColor} rx="2" />
          
          {/* Adjustable Wrench / Tool */}
          <path d="M25 75 L55 45 M50 40 L60 50" stroke={accentColor} strokeWidth="3.5" strokeLinecap="round" />
          <circle cx="25" cy="75" r="4" fill={strokeColor} />
        </svg>
      );

    case 'salg':
      return (
        <svg viewBox="0 0 100 100" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
          {/* Energy Class Badge */}
          <rect x="18" y="20" width="64" height="60" rx="6" fill={fillColor} stroke={strokeColor} strokeWidth="2.5" />
          <path d="M26 32 H55 L62 38 L55 44 H26 Z" fill="#192330" />
          <text x="32" y="41" fill="#ffffff" fontSize="10" fontWeight="bold" fontFamily="sans-serif">A+++</text>
          
          <path d="M26 48 H48 L53 53 L48 58 H26 Z" fill={accentColor} />
          <text x="32" y="55" fill="#ffffff" fontSize="8" fontWeight="bold" fontFamily="sans-serif">A++</text>

          {/* Price Tag / Discount Ribbon */}
          <circle cx="70" cy="65" r="12" fill={accentColor} stroke={strokeColor} strokeWidth="2" />
          <path d="M64 65 L76 65 M70 59 L70 71" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );

    case 'service':
    default:
      return (
        <svg viewBox="0 0 100 100" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
          {/* Clipboard Inspection Sheet */}
          <rect x="22" y="20" width="56" height="66" rx="4" fill={fillColor} stroke={strokeColor} strokeWidth="2.5" />
          <rect x="38" y="14" width="24" height="10" rx="2" fill={accentColor} stroke={strokeColor} strokeWidth="2" />
          
          <path d="M32 36 H68 M32 48 H68 M32 60 H54" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" />
          
          {/* Systematic Checkmarks */}
          <path d="M60 58 L64 62 L72 54" stroke={accentColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
  }
}
